"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hub = exports.ElementContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricks = require("../bricks.js");
var _bricksUtils = require("@titelmedia/bricks-utils");
var _lodash = require("lodash");
var _Layout = _interopRequireDefault(require("../Layout"));
var _Hero = _interopRequireDefault(require("./Hero"));
var _Images = _interopRequireDefault(require("./Images"));
var _Separator = _interopRequireDefault(require("./Separator"));
var _ArticleAggregator = _interopRequireDefault(require("./ArticleAggregator"));
var _PosterImageOrVideo = _interopRequireDefault(require("./PosterImageOrVideo"));
var _Video = _interopRequireDefault(require("./Video"));
var _CtaCredits = _interopRequireDefault(require("./CtaCredits"));
var _styles = require("./styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
_bricksUtils.gsap.registerPlugin(_bricksUtils.ScrollTrigger);
const ElementContainer = ({
  children,
  elType
}) => {
  let container = 'md';
  switch (elType) {
    case 'Paragraph':
      container = 'md';
      break;
    case 'Quote':
      container = 'lg';
      break;
    default:
      container = 'lg';
      break;
  }
  return _react.default.createElement(_styles.Container, {
    container: container
  }, children);
};
exports.ElementContainer = ElementContainer;
const HubContent = ({
  story
}) => {
  const containerRef = (0, _react.useRef)(null);
  const triggerRef = (0, _react.useRef)(null);
  const tlRef = (0, _react.useRef)(null);
  const initTl = () => {
    if (window.innerWidth >= 768) {
      const scrollTriggerOptions = {
        trigger: triggerRef.current,
        start: 'top top',
        end: `+=${containerRef.current.offsetWidth}`,
        scrub: true,
        pin: true
      };
      const offset = `-${containerRef.current.offsetWidth - window.innerWidth}px`;
      tlRef.current = _bricksUtils.gsap.timeline({
        scrollTrigger: scrollTriggerOptions
      }).to(containerRef.current, {
        x: offset,
        ease: 'power2.out',
        duration: 3
      });
    }
  };
  const myResize = () => {
    tlRef.current?.scrollTrigger.kill(true);
    tlRef.current?.kill();
    setTimeout(initTl, 200);
  };
  const onResize = (0, _lodash.debounce)(myResize, 200);
  (0, _react.useEffect)(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  (0, _react.useEffect)(() => {
    initTl();
  }, []);
  const getElement = elType => {
    switch (elType) {
      case 'Hero':
        return _Hero.default;
      case 'Separator':
        return _Separator.default;
      case 'CtaCredits':
        return _CtaCredits.default;
      case 'Images':
        return _Images.default;
      case 'Video':
        return _Video.default;
      case 'ArticleAggregator':
        return _ArticleAggregator.default;
      case 'PosterImageOrVideo':
        return _PosterImageOrVideo.default;
      default:
        return null;
    }
  };
  return _react.default.createElement(_styles.Trigger, _extends({
    ref: triggerRef
  }, story[0].data), _react.default.createElement(_styles.Wrapper, _extends({
    ref: containerRef
  }, story[0].data), story.map((section, index) => {
    return _react.default.createElement(_react.default.Fragment, null, section.elements?.map((el, indexEl) => {
      let Element;
      if (getElement(el.type)) {
        Element = getElement(el.type);
        return _react.default.createElement(Element, el.data);
      } else {
        Element = _bricks.BRICKS.elements[el.type];
        if (Element) {
          return _react.default.createElement(ElementContainer, {
            elType: el.type
          }, _react.default.createElement(Element, _extends({
            key: `section--${index}__element--${indexEl}`,
            id: `section--${index}__element--${indexEl}`
          }, el.data)));
        } else {
          console.error(`No element ${indexEl} of type ${el.type}`);
          return null;
        }
      }
    }));
  })));
};
const Hub = ({
  story
}) => {
  return _react.default.createElement(_Layout.default, null, _react.default.createElement(HubContent, {
    story: story
  }));
};
exports.Hub = Hub;
//# sourceMappingURL=index.js.map